'use client'

import type { ReactNode } from 'react'

import { TabsTrigger } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'

export type UnavailableLineTabTriggerProps = {
  value: string
  /** Short mode label for aria (e.g. "Analysis", "Invite"). */
  label: string
  unavailableTitle: string
  children: ReactNode
  className?: string
}

/** Visible line tab that cannot be activated (draft job, unpublished, etc.). */
export function UnavailableLineTabTrigger({
  value,
  label,
  unavailableTitle,
  children,
  className,
}: UnavailableLineTabTriggerProps) {
  const ariaLabel = `${label} unavailable. ${unavailableTitle}`

  return (
    <TabsTrigger
      variant="line"
      value={value}
      className={cn(
        'gap-2 text-muted-foreground/60 hover:text-muted-foreground/60',
        className,
      )}
      aria-disabled="true"
      title={unavailableTitle}
      aria-label={ariaLabel}
    >
      {children}
    </TabsTrigger>
  )
}
